/**
 * Enforces custom.limit_per_order metafield on product page and cart drawer.
 * Limits are stored as line item property _limit_per_order and surfaced as
 * max attributes on quantity inputs in Liquid templates.
 */
(function () {

  // ── Helpers ──────────────────────────────────────────────────────────────

  function getMax(input) {
    const max = parseInt(input.getAttribute('max'));
    return isNaN(max) ? null : max;
  }

  function capToMax(input) {
    const max = getMax(input);
    if (max === null) return false;
    const val = parseInt(input.value);
    if (val > max) {
      input.value = max;
      return true;
    }
    return false;
  }

  function flashNotice(input, message) {
    const id = 'socal-limit-notice-' + (input.id || Math.random().toString(36).slice(2));
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('span');
      el.id = id;
      el.style.cssText = [
        'display:inline-block',
        'color:#c6a75e',
        'font-size:12px',
        'font-family:Oswald,sans-serif',
        'letter-spacing:.5px',
        'margin-left:8px',
        'vertical-align:middle',
      ].join(';');
      const ref = input.closest('.js-qty, .cart-drawer__product-card--quantity');
      if (ref) ref.appendChild(el);
    }
    el.textContent = message;
    clearTimeout(el._timer);
    el._timer = setTimeout(() => el.remove(), 2500);
  }

  async function fetchCart() {
    const res = await fetch('/cart.json');
    return res.json();
  }

  // ── Product page: check cart qty before allowing add-to-cart ─────────────

  function initProductPageLimit() {
    const form = document.querySelector('[data-type="add-to-cart-form"]');
    if (!form) return;

    const limitInput = form.querySelector('input[name="properties[_limit_per_order]"]');
    if (!limitInput) return;

    const limit = parseInt(limitInput.value);
    if (!limit || isNaN(limit)) return;

    // Cart qty keyed by variant ID, populated on load and kept fresh after adds
    const cartQtyByVariant = {};

    function getVariantId() {
      const el = form.querySelector('.product-variant-id');
      return el ? parseInt(el.value) : null;
    }

    function getQtyInputValue() {
      const el = document.querySelector('.js-qty__num');
      return el ? Math.max(1, parseInt(el.value) || 1) : 1;
    }

    function showErrorBanner(msg) {
      let banner = document.getElementById('socal-atc-limit-banner');
      if (!banner) {
        banner = document.createElement('p');
        banner.id = 'socal-atc-limit-banner';
        banner.style.cssText = [
          'color:#a8893e',
          'background:#fff8ee',
          'border:1px solid #c6a75e',
          'font-family:Oswald,sans-serif',
          'font-size:13px',
          'letter-spacing:.5px',
          'padding:8px 14px',
          'border-radius:2px',
          'margin:0 0 10px',
        ].join(';');
        const errorEl = form.querySelector('[data-qty-error-message]');
        if (errorEl) errorEl.parentNode.insertBefore(banner, errorEl);
      }
      banner.textContent = msg;
      banner.style.display = 'block';
    }

    function hideErrorBanner() {
      const banner = document.getElementById('socal-atc-limit-banner');
      if (banner) banner.style.display = 'none';
    }

    function updateProductPageState() {
      const variantId = getVariantId();
      if (!variantId) return;
      const existingQty = cartQtyByVariant[variantId] || 0;
      const remaining = limit - existingQty;

      const qtyInput = document.querySelector('.js-qty__num');
      const submitBtn = form.querySelector('[name="add"]');

      if (remaining <= 0) {
        if (qtyInput) { qtyInput.setAttribute('max', '0'); qtyInput.value = 0; }
        if (submitBtn && !submitBtn.disabled) submitBtn.disabled = true;
        showErrorBanner('You already have the maximum (' + limit + ') in your cart.');
      } else {
        if (qtyInput) {
          qtyInput.setAttribute('max', String(remaining));
          const cur = parseInt(qtyInput.value);
          if (cur > remaining) qtyInput.value = remaining;
        }
        if (submitBtn) submitBtn.disabled = false;
        hideErrorBanner();
      }
    }

    // Load cart on page open
    fetchCart().then(cart => {
      cart.items.forEach(item => {
        cartQtyByVariant[item.variant_id] = (cartQtyByVariant[item.variant_id] || 0) + item.quantity;
      });
      updateProductPageState();
    });

    // Re-check whenever the selected variant changes (theme replaces hidden input value)
    const variantInput = form.querySelector('.product-variant-id');
    if (variantInput) {
      new MutationObserver(updateProductPageState).observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      variantInput.addEventListener('change', updateProductPageState);
    }

    // Intercept add-to-cart submit in capture phase — runs before the theme's handler
    form.addEventListener('submit', function (e) {
      const variantId = getVariantId();
      if (!variantId) return;
      const existingQty = cartQtyByVariant[variantId] || 0;
      const qtyToAdd = getQtyInputValue();

      if (existingQty + qtyToAdd > limit) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const remaining = Math.max(0, limit - existingQty);
        showErrorBanner(
          remaining > 0
            ? 'You can only add ' + remaining + ' more (limit: ' + limit + ' per order).'
            : 'You already have the maximum (' + limit + ') in your cart.'
        );
        return;
      }

      // Optimistically update cached qty so a rapid double-submit is also blocked
      cartQtyByVariant[variantId] = (cartQtyByVariant[variantId] || 0) + qtyToAdd;
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPageLimit);
  } else {
    initProductPageLimit();
  }


  // ── Cart drawer qty input — cap typed value before component's handler ────

  // Plus button: block at max (capture phase)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-cart-quantity-button][name="plus"]');
    if (!btn) return;
    const cartQty = btn.closest('cart-quantity');
    if (!cartQty) return;
    const input = cartQty.querySelector('[data-cart-quantity-input]');
    if (!input) return;
    const max = getMax(input);
    if (max === null) return;
    if (parseInt(input.value) >= max) {
      e.stopImmediatePropagation();
      flashNotice(input, 'Max ' + max + ' per order');
    }
  }, true);

  // Typed input: cap before cart-quantity component reads it (capture phase)
  document.addEventListener('change', function (e) {
    if (!e.target.hasAttribute('data-cart-quantity-input')) return;
    const capped = capToMax(e.target);
    if (capped) flashNotice(e.target, 'Max ' + getMax(e.target) + ' per order');
  }, true);

  // ── Cart page form submit — block if any qty input exceeds its max ─────────

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[data-wetheme-section-type="template--cart"]');
    if (!form) return;

    let blocked = false;
    form.querySelectorAll('input.js-qty__num[max]').forEach(function (input) {
      const max = getMax(input);
      if (max === null) return;
      const val = parseInt(input.value);
      if (val > max) {
        input.value = max;
        blocked = true;
      }
    });

    if (blocked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      let banner = document.getElementById('socal-cart-page-banner');
      if (!banner) {
        banner = document.createElement('p');
        banner.id = 'socal-cart-page-banner';
        banner.style.cssText = [
          'color:#a8893e',
          'background:#fff8ee',
          'border:1px solid #c6a75e',
          'font-family:Oswald,sans-serif',
          'font-size:13px',
          'letter-spacing:.5px',
          'padding:8px 14px',
          'border-radius:2px',
          'margin:0 0 14px',
          'text-align:center',
        ].join(';');
        form.insertBefore(banner, form.firstChild);
      }
      banner.textContent = 'One or more quantities have been reduced to the per-order limit. Please review and try again.';
      banner.style.display = 'block';
    }
  }, true);

  // Product page qty stepper plus button — cap after theme increments
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.js-qty__adjust--plus');
    if (!btn) return;
    const input = btn.closest('.js-qty')?.querySelector('.js-qty__num');
    if (!input) return;
    const max = getMax(input);
    if (max === null) return;
    setTimeout(() => {
      const capped = capToMax(input);
      if (capped) flashNotice(input, 'Max ' + max + ' per order');
    }, 0);
  });

  // Product page qty text input — cap on change
  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('js-qty__num')) return;
    const capped = capToMax(e.target);
    if (capped) flashNotice(e.target, 'Max ' + getMax(e.target) + ' per order');
  });

})();
